module.exports = __webpack_public_path__ + "img/1-1.50c3d298.png";